/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CampaignPipelineConfigResetToDefaultsPathParams,
	CampaignPipelineConfigResetToDefaultsRequest,
	CampaignPipelineConfigResetToDefaultsResponse,
} from '../types/CampaignPipelineConfigResetToDefaults'

/**
 * POST /campaigns/:campaign/pipeline-config/reset-to-defaults
 * @see backend/nexus/modules/Campaign/Http/Controllers/CampaignPipelineConfigController.php CampaignPipelineConfigController::resetToDefaults
 */
export async function campaignPipelineConfigResetToDefaults(
	campaign: CampaignPipelineConfigResetToDefaultsPathParams['campaign'],
	data: CampaignPipelineConfigResetToDefaultsRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignPipelineConfigResetToDefaultsResponse>> {
	return axiosInstance.post(`/campaigns/${campaign}/pipeline-config/reset-to-defaults`, data, config)
}
